import { helper } from '@ember/component/helper';

export default helper(function inspect(positional /*, named*/) {
  let [item] = positional;

  console.log(item);
});
